import { toast } from "react-toastify";
import getUserKey from "./getUserKey";

const errorHandle = (err) => {
  if (err?.response?.status === 401) {
    localStorage.removeItem(getUserKey());
    return window.location.href = "/login"
  }

  toast.error(err?.response?.data?.error || err?.message || 'Something Went Wrong!', { position: 'bottom-right' });
  return err?.response?.data?.error || err?.message || 'Something Went Wrong!'
}

export default errorHandle;